export default {"src":"/_next/static/media/Logo_Horizontal_Light.8a1483da.svg","height":48,"width":265};